import { takeUntil } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AppToolbarOptionsComponent } from '@ifaa-components/ui-components';
import { AccountUnderlyingInvestmentSummaryViewComponent } from 'src/app/modules/shared/components/account-underlying-investment-summary-view/account-underlying-investment-summary-view.component';
import { AppComponentWrapperComponent } from 'src/app/modules/shared/components/app-component-wrapper/app-component-wrapper.component';
import { AnimateCssDirective } from 'src/app/modules/shared/directives/animatecss.directive';
import { TextTransformPipe } from 'src/app/modules/shared/pipes/textTransform';

@Component({
  selector: 'app-underlying-investment-view',
  templateUrl: './underlying-investment-view.component.html',
  styleUrls: ['./underlying-investment-view.component.scss'],
  host: {
    class: 'w-100',
  },
  imports: [
    AccountUnderlyingInvestmentSummaryViewComponent,
    AppComponentWrapperComponent,
    AppToolbarOptionsComponent,
    TextTransformPipe,
    TranslatePipe,
    AnimateCssDirective,
  ],
})
export class UnderlyingInvestmentViewComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  title: string = '';
  constructor(
    public store: Store<AppState>,
    public translate: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  setTitle(event) {
    this.translate
      .get('VIEWS.UnderlyingInvestments.subtitle')
      .pipe(takeUntil(this.destroy$))
      .subscribe((x) => {
        if (x) {
          this.title = x;
        } else {
          this.title = event;
        }
      });
  }
}
